// extracted by mini-css-extract-plugin
export default {"dropdown":"dropdown_dropdown__G2xjN"};